import { NgClass, NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { checkModifica } from 'app/utils/boolean-input';

@Component({
  selector: 'app-social-links',
  standalone: true,
  imports: [MatIconModule, NgClass],
  templateUrl: './social-links.component.html',
})
export class SocialLinksComponent {

    @Input() data:boolean;

    checkModifica(){
        return checkModifica()
    }

}
